export const getAllItems = (state: App.State) =>
  state.cart.offers.reduce<App.CartItem[]>((allItems, offer) => [...allItems, ...offer.items], []);

export const getAllAddons = (state: App.State) =>
  state.cart.offers.reduce<App.CartAddon[]>((allAddons, offer) => [...allAddons, ...offer.addons], []);
